import React from 'react'
import Store from '../../store/store'
import Upload from './steps/upload'
import HeaderSteps from './headersteps'
import Download from './steps/download'
import BaseComponent from '../base'
import api from "../../source/api";
import NotificationSystem from "react-notification-system";

class Cashregister extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            company: null,
            config: null,
            currentStep: 1,

            files: [],
            totalSummarization: [],
            summarization: []
        }
        this.store = Store

    }

    notifySuccess = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'success',
            position: 'tc',
            autoDismiss: 10
        })
    };

    notifyError = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'error',
            position: 'tc',
            autoDismiss: 10
        })
    };

    componentDidMount = () => {
        api.get('cashregister/' + this.props.location.match.params.id + '/init')
            .then((response) => {
                this.setState({
                    config: response.data.config,
                    company: response.data.company,
                    onlineszamlaToken: response.data.onlineszamlaToken
                })
            })
    }

    nextStep = () => {
        this.setStep(this.state.currentStep + 1);
    }

    setStep = (step) => {
        this.setState({currentStep: step});
    }

    setOutputFiles = (data) => {
        this.setState({
            files: data.file,
            totalSummarization: data.totalSummarization,
            summarization: data.summarization,
        })
    }

    render() {
        if (!this.state.company) {
            return <section id='cashregister-upload'>
                <NotificationSystem ref='notificationSystem'/>
            </section>;
        }

        return (
            <section id='cashregister-upload'>
                <HeaderSteps
                    currentStep={this.state.currentStep}
                    setStep={(step) => this.setStep(step)}
                />
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-10 offset-1'>
                                <h1 className='text-center'>
                                    Pénztárgépszalagok automatikus könyvelése
                                </h1>

                                <div className={this.state.currentStep == 1 ? 'col-12' : 'd-none'}>
                                    <p>
                                        Töltse fel a könyvelt cégtől kapott pénztárszalag XML-eket, ZIP-ben. Válassza ki az Ön által használt könyvelőprogramot, amennyiben először használja az adott modult, kérjük, paraméterezze fel az adott cég Főkönyvi struktúráját.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='upload-body'>
                    <div className='container'>
                        {this.state.currentStep === 1
                            ? <Upload
                                company={this.state.company}
                                config={this.state.config}
                                onlineszamlaToken={this.state.onlineszamlaToken}
                                setOutputFiles={(files) => this.setOutputFiles(files)}
                                nextStep={() => this.nextStep()}
                                setValue={(name, value, error) => this.setValue(name, value, error)}
                                notifySuccess={(msg) => this.notifySuccess(msg)}
                                notifyError={(msg) => this.notifyError(msg)}
                            />
                            : null
                        }
                        {this.state.currentStep === 2
                            ? <Download
                                company={this.state.company}
                                files={this.state.files}
                                summarization={this.state.summarization}
                                totalSummarization={this.state.totalSummarization}
                                notifySuccess={(msg) => this.notifySuccess(msg)}
                                notifyError={(msg) => this.notifyError(msg)}
                            />
                            : null
                        }
                    </div>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Cashregister


// WEBPACK FOOTER //
// ./src/components/cashregister/cashregister.js